import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/homepages/sections/offline_stores'

const CmsHomepageSectionOfflineStoresApiV2 = {

  /**
   * Get list of Cms Homepage Section Offline Stores
   * Invoke `GET api/v2/admins/cms/homepages/sections/offline_stores'
   */
  get: async () => {
    const path = API_PATH

    const response = await axios.get(path, { })
    return response
  },
  /**
   * Get Cms Homepage Section Offline Stores and Content
   * Invoke `GET api/v2/admins/cms/homepages/sections/offline_stores/:id'
   * @param {string} id - id of section
   */
  show: async (id) => {
    const path = `${API_PATH}/${id}`

    const response = await axios.get(path, { })
    return response
  },
  /**
   * Update Cms Homepage Section Community Favorite
   * Invoke `PATCH api/v2/admins/cms/homepages/sections/offline_stores/:id'
   * @param {string} id - id of section community favorite
   * @param {boolean} is_active - is_active value get from table column
   */
  update: async ( id, payload) => {
    const path = `${API_PATH}/${id}`

    const response = axios.patch(path, payload)

    return response
  }
}

export default CmsHomepageSectionOfflineStoresApiV2
